import {AUTO_DELIVERY_FREQUENCY_TYPES, AutoDeliveryFrequency} from '@/consts/icc/iccAutoDeliveryStatusTypes';
import appContent from '@/services/content/appContent.typed';
import type {AutoDeliveryContent} from '@/types/content';

type GetAutoDeliveryDcxFrequencyLabelParams = {
    frequency: AutoDeliveryFrequency;
    autoDeliveryContent: Pick<
        AutoDeliveryContent,
        | 'deliveryDailyFrequencyLabel'
        | 'deliveryWeeklyFrequencyLabel'
        | 'deliveryBiweeklyFrequencyLabel'
        | 'deliveryMonthlyFrequencyLabel'
        | 'deliveryBimonthlyFrequencyLabel'
    >;
};

export const getAutoDeliveryDcxFrequencyLabel = ({
    frequency,
    autoDeliveryContent: {
        deliveryDailyFrequencyLabel,
        deliveryWeeklyFrequencyLabel,
        deliveryBiweeklyFrequencyLabel,
        deliveryMonthlyFrequencyLabel,
        deliveryBimonthlyFrequencyLabel,
    },
}: GetAutoDeliveryDcxFrequencyLabelParams): string => {
    const normalizedFrequency = frequency?.toUpperCase();

    switch (normalizedFrequency) {
        case AUTO_DELIVERY_FREQUENCY_TYPES.DAILY:
            return deliveryDailyFrequencyLabel;
        case AUTO_DELIVERY_FREQUENCY_TYPES.WEEKLY:
            return deliveryWeeklyFrequencyLabel;
        case AUTO_DELIVERY_FREQUENCY_TYPES.BIWEEKLY:
            return deliveryBiweeklyFrequencyLabel;
        case AUTO_DELIVERY_FREQUENCY_TYPES.MONTHLY:
            return deliveryMonthlyFrequencyLabel;
        case AUTO_DELIVERY_FREQUENCY_TYPES.BIMONTHLY:
            return deliveryBimonthlyFrequencyLabel;
        default:
            return '';
    }
};

export const getAutoDeliveryDcxFrequencyLabelFromAppContent = (frequency: AutoDeliveryFrequency): string => {
    return getAutoDeliveryDcxFrequencyLabel({
        frequency,
        autoDeliveryContent: appContent.getAutoDeliveryContent(),
    });
};
